
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events-delegate-terms-and-conditions",
      function () {
        return require("private-next-pages/events-delegate-terms-and-conditions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events-delegate-terms-and-conditions"])
      });
    }
  